import { render, staticRenderFns } from "./ChatReconstructionCard.vue?vue&type=template&id=774d9739&scoped=true"
import script from "./ChatReconstructionCard.vue?vue&type=script&lang=js"
export * from "./ChatReconstructionCard.vue?vue&type=script&lang=js"
import style0 from "./ChatReconstructionCard.vue?vue&type=style&index=0&id=774d9739&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774d9739",
  null
  
)

export default component.exports